import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { changeLanguage } from '../../i18n';
import styles from './LanguageSwitcher.module.css';

/* A two-segment control rather than two links with a pipe between
   them. The pipe made both options look equally inactive; a filled
   chip on the current language says which one you are actually in. */
const LANGUAGES = [
  { code: 'en', label: 'EN', switchLabel: 'Switch to English' },
  { code: 'es', label: 'ES', switchLabel: 'Cambiar a Español' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = i18n.language?.startsWith('es') ? 'es' : 'en';

  const handleLanguageChange = (lang) => {
    if (lang !== currentLang) {
      changeLanguage(lang, location.pathname, navigate);
    }
  };

  return (
    <div className={styles.switcher} role="group" aria-label="Language">
      {LANGUAGES.map(({ code, label, switchLabel }) => {
        const isActive = currentLang === code;
        return (
          <button
            key={code}
            type="button"
            className={`${styles.segment} ${isActive ? styles.active : ''}`}
            onClick={() => handleLanguageChange(code)}
            aria-label={switchLabel}
            aria-pressed={isActive}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
